import React, { forwardRef, useState } from 'react'
import { Send } from '../imgs/imgs';
import { Element } from 'react-scroll';

const Waitlist = forwardRef((props, ref) => {
  const [email,setEmail] = useState(null)
  const [message,setMessage] = useState(null)
  const [loading,setLoading] = useState(false)
  const SetMail = (e)=>{
    console.log(e.target.value)
    setEmail(e.target.value)

  }
  
  const sendData = async (event) => {
    event.preventDefault();

    try {
        setLoading(true)
        const response = await fetch('https://getlaunchlist.com/s/i7sS8m', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        setLoading(false)
        

        if (response.ok) {
           
            setMessage('Thanks for joining the waitlist!');
            setEmail(null); // Clear the input field
        } else {
            setMessage('There was an error. Please try again.');
        }
    } catch (error) {
        setMessage('There was an error. Please try again.');
        // console.error('Error:', error);
    }
};
  return (
    <Element name="waitlist" className='w-full bg-slate-50'>
        <div className='w-full max-w-[1600px] bg-slate-50 mx-auto text-center p-[50px] md:p-[100px] flex justify-center items-center flex-col'>
            <h1 className='text-[30px] md:text-[40px] font-semibold mb-[5px] font-poppins'>Join Our Waitlist</h1>
            <p className='text-[15px] md:text-[16.5px] font-figtree mb-[30px] w-[80%]'>Step into the driver's seat of our vibrant community!
            Drop your email below and ignite the journey with us.</p>
            <div className='w-full max-w-[1000px] relative' >
            <input onChange={(e)=>SetMail(e)} type='text' className='w-full p-[10px] pr-[40px] shadow-md rounded-md h-[50px]' placeholder='Your email' required/>
            <img onClick={sendData} src={Send} className='absolute right-[10px] h-[50%] cursor-pointer top-1/2 transform -translate-y-1/2'/>
            </div>
            {loading && <div className='w-full h-auto flex justify-center items-center pt-[20px] text-[18px] font-bold'> Loading
</div>}
            {message ? (

<div className='w-full h-auto flex justify-center items-center pt-[20px] text-[18px] font-bold'> {message}
</div>
): null
    
}
        </div>
        
        
      
    </Element>
  )
})

export default Waitlist
